import { Espece } from './espece.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class Variete {
    static jsonMap = {
        id: 'id',
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' },
        espece: { key: 'espece', converter: new (ClassConverterFactory.build(Espece))(), optional: true },
        varieteClone: { key: 'varieteClone', converter: new (ClassConverterFactory.build(Variete))(), optional: true }
    };

    id: number;
    code: string;
    libelle: string;
    public espece: Espece;
    public varieteClone: Variete;
}
